import { Observable } from 'rxjs';
import { CheckboxFilterComponent } from './components/checkbox-filter/checkbox-filter.component';
import { SearchbarComponent } from './components/searchbar/searchbar.component';
import { MatSort } from '@angular/material/sort';
import { PaginatorComponent } from "@/shared/components/table/components/paginator/paginator.component";
import { DataSource } from "@angular/cdk/collections";
import { FilterComponent } from '@/shared/components/table/components/filter/filter.component';
import { TemplateRef } from "@angular/core";

export interface Column<TData> {
  columnId: string;
  fieldSelector: ((item: TData) => string);
  caption: string;
  headerTemplate?: TemplateRef<any>;
  hidden?: boolean;
  sortable?: boolean;
  type?: ColumnType;
  alignment?: ColumnAlignment;
  template?: TemplateRef<any>;
}

export interface PaginationMetadata {
  previousCursors: (string | null | undefined)[];
  currentCursor: string | null | undefined;
  nextCursor: string | null | undefined;
  pageSize: number | null;
  count: number | null | undefined;
}

export interface FilterConfig {
  propertyName: string;
  filterOptions: string[];
}

export type PageDirection = 'next' | 'previous';

export enum FilterPremiumUsers {
  Premium = "PREMIUM",
  NonPremium = "NONPREMIUM",
  All = "ALL",
}

export enum ColumnType {
  Date = "DATE",
  Link = "LINK",
  Template = "TEMPLATE",
  Image = "IMAGE",
  Status = "STATUS",
}

export enum ColumnAlignment {
  Left = "LEFT",
  Right = "RIGHT",
  Centered = "CENTERED",
}

export enum InviteStatus {
  Accepted = "Accepted",
  Pending = "Pending",
  NotInvited = "Not_invited"
}

export abstract class TableDataSource<TData> extends DataSource<TData> {
  public dataChanged$: Observable<void>;
  protected _paginator: PaginatorComponent;
  abstract set paginator(component: PaginatorComponent);
  abstract set sort(direction: MatSort);
  abstract set filter(component: FilterComponent);
  abstract set searchbar(component: SearchbarComponent);
  abstract set checkboxFilter(component: CheckboxFilterComponent);
}
